exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status {\n  margin-bottom: 5px;\n}\n\n.shift-status {\n  /* border-radius: 5px; */\n  font-weight: 700;\n  width: 65px;\n  background-color: rgb(219, 219, 38)\n}\n\n.leave {\n  font-weight: 700;\n  width: 65px;\n  background-color: #777;\n}\n\n.firstHalf {\n  width: 65px;\n  background-image: linear-gradient(to right, #777 0%, #777 50%, var(--primary) 50%, var(--primary) 50%);\n\n}\n\n.secondHalf {\n  width: 65px;\n  background-image: linear-gradient(to right, var(--primary) 0%, var(--primary) 50%, #777 50%, #777 50%);\n\n}\n\n.bothShort {\n  width: 65px;\n  background-color: #777 !important;\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/attendance-status/attendance-status.component.css
// module id = ../../../../../src/app/shared/components/attendance-status/attendance-status.component.css
// module chunks = main